<template>
  <div>
    <img src="@assets/static/images/banner-paynow.png" loading="lazy" :alt="$t('SHOP.COMMON.ARIA.PAYNOW_SUPPORTED_PAYMENTS')" class="payment-partner">
  </div>
</template>

<style scoped lang="scss">
  img {
    display: block;
    width: 100%;
    height: 100%;
    aspect-ratio: 1215/200;
    max-width: min(1400px, 100%);
    max-height: 130px;
    margin-inline: auto;
    object-fit: contain;
    object-position: center;
  }
</style>
